export default __webpack_public_path__ + "static/media/login-loader.775be8b3.gif";